<template>
  <div>
    <!-- 搜索 -->
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="品牌">
            <a-select
              v-model="businessLines"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="选择域名关联品牌"
              style="width: 100%"
              @change="handleChange"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="`${item.project}-${item.type}`">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="网站名称">
            <a-input v-model="searchForm.site_keyword" allowClear placeholder="输入关键词" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="平台分类">
            <a-select mode="multiple" v-model="searchForm.platform_class" allowClear show-search option-filter-prop="children" placeholder="选择品牌分类" style="width: 100%">
              <a-select-option v-for="item in PLATFORM_CLASS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <div class="operbtnbox">
            <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
            <a-button type="primary" icon="delete" ghost @click="handleClear">重置</a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>
    <!-- 新增按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :loading="loading" :data-source="data" :pagination="pagination" class="mytable" @change="handleTableChange">
      <a-table-column title="品牌" data-index="project_name" align="center" />
      <a-table-column title="事业群" data-index="type_name" align="center" />
      <a-table-column title="网站名称" data-index="platform_name" align="center" />
      <a-table-column title="平台分类" data-index="platform_class_t" align="center" />
      <a-table-column title="域名" data-index="domain" align="center" />
      <a-table-column title="创建时间" :width="170" align="left">
        <template slot-scope="text, record">
          <span>{{ record.created_at }}</span>
        </template>
      </a-table-column>
      <a-table-column title="修订时间" :width="170" align="left">
        <template slot-scope="text, record">
          <span>{{ record.updated_at }}</span>
        </template>
      </a-table-column>
      <a-table-column title="相关人" :width="210" align="left">
        <template slot-scope="text, record">
          <div v-if="record.created_info.name && record.created_info.number">
            <span>创建人：</span>
            <span>{{ record.created_info.name }}（{{ record.created_info.number }}）</span>
          </div>
          <div v-if="record.updated_info.name && record.updated_info.number">
            <span>修订人：</span>
            <span>{{ record.updated_info.name }}（{{ record.updated_info.number }}）</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="操作" :width="180" align="center" fixed="right">
        <template slot-scope="text, record">
          <a-button size="small" type="link" @click="toCacheSite(record)">管理</a-button>
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" class="deletebtn" @click="handleTableCommand('delete', record)">删除</a-button>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加缓存站点 -->
    <addCacheSite v-if="visible" v-model="visible" :isEdit="isEdit" :params="waitItem" :platformList="platformList" @handleOver="getList" />
  </div>
</template>

<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import compuedFun from './computed/'
import pagination from '@/composables/pagination'
import api from '@/api/'
import addCacheSite from './components/addCacheSite'

export default {
  components: { addCacheSite },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      platformList: [],
      businessLines: undefined,
      searchForm: { ...searchForm }
    })
    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })
    const methods = {
      search() {
        _this.pagination.current = 1
        methods.getList()
      },
      // 列表数据
      async getList() {
        _this.loading = true
        const res = await api.cacheSiteList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { site, pagination } = res.data
        _this.data = site
        _this.pagination.total = pagination.total
        _this.loading = false
      },
      // 平台枚举
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data.filter(item => {
          if ([0, 1].includes(item.depth)) {
            return item
          }
        })
      },
      // 平台下拉选择
      handleChange() {
        if (state.businessLines) {
          state.searchForm.project = state.businessLines.split('-')[0]
          state.searchForm.type = state.businessLines.split('-')[1]
        } else {
          state.searchForm.project = ''
          state.searchForm.type = ''
        }
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      // 重置
      handleClear() {
        state.businessLines = undefined
        state.searchForm = { ...searchForm }
        this.search()
      },
      // 新增
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
        _this.waitItem = null
      },
      // 站点-缓存管理
      toCacheSite(item) {
        _this.$router.push({
          path: '/websiteAdmin/cacheSite',
          query: {
            id: item.id,
            project: item.project,
            type: item.type,
            platform_class: item.platform_class,
            platform_name: item.platform_name,
            domain: item.domain
          }
        })
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>

<style scoped lang="less">
.operbtnbox {
  padding: 4px 0;
}

.mytable {
  margin-top: 20px;

  .deletebtn {
    color: #ff4d4f;

    &:hover {
      color: #ff7875;
    }
  }
}
</style>
